import { Injectable, signal } from '@angular/core';

export interface ConfirmRequest {
  message: string;
  acceptLabel?: string;
  rejectLabel?: string;
}

interface PendingConfirm extends ConfirmRequest {
  resolve: (accepted: boolean) => void;
}

/**
 * Promise-based, so call sites read `if (await confirm.ask(...))` instead of threading
 * an accept callback. One outlet in the shell renders whatever is pending.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  readonly pending = signal<PendingConfirm | null>(null);

  ask(request: ConfirmRequest): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.pending.set({ ...request, resolve });
    });
  }

  /** Called by the outlet only. */
  settle(accepted: boolean): void {
    const current = this.pending();
    this.pending.set(null);
    current?.resolve(accepted);
  }
}
